import { useEffect, useRef, useState } from "react";
import CommonTable from "../../../components/comman/CommonTable";
import MainHeading from "../../../components/comman/MainHeading";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { callApi } from "../../../ApiHelper/ApiHelper";
import moment from "moment";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  Fade,
  TabPane,
  Spinner,
} from "reactstrap";
import FilterComponent from "../../../components/comman/FilterComponent";
import { useDispatch, useSelector } from "react-redux";
import ExportDataHandler from "../../../utility/ExportDataHandler";
import LockAttConfirmationModel from "./LockAttConfirmationModel";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ViewIcon from "../../../components/Icons/ViewIcon";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import {
  saveActiveSummaryTab,
  updateDateFilter,
  updateFiltersStates,
} from "../../../store/actions/UserActions";

export default function AttendanceSummary() {
  const userDetails = useSelector((state) => state.root.userDetails);
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const dateFilter = useSelector((state) => state.root.months);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ActiveTab = useSelector(
    (state) => state?.root?.activeAttendanceSummaryTab,
  );
  const [isLoading, setIsLoading] = useState(false);
  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    filterData: "",
    attendanceList: [],
    siteList: [],
    officeList: [],
    siteId: filterDetails?.siteId,
    ...(userDetails?.type === 2 ||
      (userDetails?.type == 1 && userDetails?.department?.name === "HRM") ||
      (userDetails?.type == 1 && userDetails?.department?.name === "Management")
      ? { staffType: ActiveTab == "2" ? "0" : "1" }
      : { staffType: "0" }),
    companyList: [],
    searchQuery: "",
    officeType: "",
    attendanceType: "",
    attendanceStatus: "",
    designationList: [],
    departmentList: [],
    isSalaryCreated: false,
    isPreviewGenerated: false,
    isAllDataReceived: false,
    companyIsLoading: false,
    isInitial: true,
    isLoadingSite: false,
  });
  const [modal, setModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const timeoutId = useRef(null);

  const toggleModal = (type = "") => {
    if (!pageStates?.isAllDataReceived) {
      toast.error("Please Mark All Users Attendance First.");
      return;
    }
    setModalType(type);
    setModal((prev) => !prev);
  };

  useEffect(() => {
    if (
      userDetails?.type == 2 ||
      (userDetails?.type == 1 && userDetails?.department?.name === "HRM") ||
      (userDetails?.type == 1 && userDetails?.department?.name === "Management")
    ) {
      getDepartmentAndDesignation("office");
      GetCompanyList();
      GetSiteList();
      GetOfficeList();
    } else {
      GetSiteList();
      getDepartmentAndDesignation("site");
      GetCompanyList();
      GetOfficeList();
    }
  }, []);

  useEffect(() => {
    GetSummary(pageStates?.currentPage);
  }, [
    pageStates?.staffType,
    pageStates.searchQuery,
    pageStates.attendanceStatus,
    pageStates.attendanceType,
    pageStates.officeType,
    filterDetails?.currentPage,
    filterDetails?.siteId,
    dateFilter,
    filterDetails.pageSize,
    filterDetails?.department,
    filterDetails?.designation,
    filterDetails?.companyId,
    filterDetails?.orderBy,
  ]);

  const GetSummary = (pageNo) => {
    let options = {
      method: "GET",
    };
    const filterData = {
      ...filterDetails,
      staffType: pageStates?.staffType,
      months: dateFilter,
      searchQuery: pageStates?.searchQuery,
      siteId: pageStates?.siteId,
    };
    delete filterData?.year;
    delete filterData?.sortByDate;
    const Url =
      apiUrl.get_attendance_summary + "?" + MainFilterHandler(filterData);
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.user?.map((item) => ({
          ...item,
          empNameWithImage: item?.name + "##" + item?.profilePhoto,
          shiftTime: item?.Shift?.shiftName,
          departmentName: item?.department?.name,
          officeName: item?.site?.name,
          siteName: item?.usersites?.[0]?.site?.name,
          presentDays: String(item?.totalAttendance),
          absent: String(item?.totalAbsent),
          leaves: String(item?.totalLeave),
          wfh: String(item?.totalWfh),
          pendingWfh: String(item?.totalPendingWFH),
          // halfDay: String(item?.totalHalfDays),
          totalDay: String(item?.totalDays),
          pending: String(item?.totalPending),
          pendingAr: String(item?.totalPendingAR),
          pendingOd: String(item?.totalPendingOD),
          pendingLeave: String(item?.totalPendingLeave),
          designationName: item?.designation?.name,
        }));
        setPageStates((pre) => ({
          ...pre,
          attendanceList: newData,
          isSalaryCreated: res?.data?.isSalaryCreated,
          isAllDataReceived: res?.data?.isAllDataReceived,
          isPreviewGenerated: res?.data?.isPreviewGenerated,
        }));
        dispatch(
          updateFiltersStates({
            count: res?.data?.pageInfo?.total,
            totalPages: res?.data?.pageInfo?.totalPages,
          }),
        );
      }
    });
  };

  const GetCompanyList = (inputValue = null) => {
    return new Promise((resolve) => {
      let API = `${apiUrl.get_company}${inputValue ? `?search=${inputValue}` : ""
        }`;
      let options = { method: "GET" };

      setPageStates((prev) => ({
        ...prev,
        companyIsLoading: true,
      }));

      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            const formattedData = response?.data?.company.map((company) => ({
              value: company.id,
              label: company.name,
            }));

            setPageStates((prev) => ({
              ...prev,
              companyIsLoading: false,
              companyList: formattedData,
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const toggleTab = (tab) => {
    dispatch(saveActiveSummaryTab(tab));
    if (tab == 1) {
      setPageStates((prev) => ({
        ...prev,
        staffType: "1",
        siteId: "",
        officeName: "",
      }));
      dispatch(
        updateFiltersStates({
          companyId: "",
          siteId: "",
          currentPage: 1,
          department: "",
          pageSize: 10,
        }),
      );
      getDepartmentAndDesignation("office");
    } else {
      setPageStates((prev) => ({
        ...prev,
        staffType: "0",
        siteId: "",
        officeName: "",
      }));
      dispatch(
        updateFiltersStates({
          companyId: "",
          siteId: "",
          currentPage: 1,
          pageSize: 10,
          department: "",
          designation: "",
        }),
      );
      GetSiteList();
      getDepartmentAndDesignation("site");
    }
  };

  const getDepartmentAndDesignation = (type, id) => {
    const url =
      type === "designation"
        ? apiUrl.get_designation + `?departmentId=${id}`
        : apiUrl.get_department + `?type=${type}`;
    callApi(url, { method: "GET" }).then((res) => {
      if (res?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          ...(type === "designation"
            ? {
              designationList: res?.data?.designation,
              // designation: ""
            }
            : { departmentList: res?.data?.department }),
        }));
      }
    });
  };

  const TableHeadingOffice = [
    { value: "empNameWithImage", label: "Employee" },
    { value: "employeeCode", label: "Emp. Code" },
    { value: "shiftTime", label: "Shift" },
    { value: "departmentName", label: "Department" },
    { value: "designationName", label: "Designation" },
    { value: "officeName", label: "Office" },
    { value: "presentDays", label: "Present" },
    { value: "pending", label: "Pending" },
    { value: "absent", label: "Absent" },
    // { value: "halfDay", label: "Half Day" },
    { value: "leaves", label: "Leaves" },
    { value: "wfh", label: "WFH" },
    { value: "pendingWfh", label: "Pending WFH" },
    { value: "pendingAr", label: "Pending AR" },
    { value: "pendingOd", label: "Pending OD" },
    { value: "pendingLeave", label: "Pending Leave" },
    { value: "totalDay", label: "Total Days" },
  ];

  const TableHeadingSite = [
    { value: "empNameWithImage", label: "Employee" },
    { value: "employeeCode", label: "Emp. Code" },
    { value: "shiftTime", label: "Shift" },
    { value: "departmentName", label: "Department" },
    { value: "designationName", label: "Designation" },
    { value: "siteName", label: "Site" },
    { value: "presentDays", label: "Present Days" },
    { value: "pending", label: "Pending" },
    { value: "absent", label: "Absent Days" },
    // { value: "halfDay", label: "Half Day " },
    { value: "leaves", label: "Leaves" },
    { value: "wfh", label: "WFH" },
    { value: "pendingWfh", label: "Pending WFH" },
    { value: "pendingAr", label: "Pending AR" },
    { value: "pendingOd", label: "Pending OD" },
    { value: "pendingLeave", label: "Pending Leave" },
    { value: "totalDay", label: "Total Days" },
  ];

  const HandleViewPending = (data) => {
    navigate(RoutesLink.attendance_summary_details + `/${data?.id}`, {
      state: { data, month: dateFilter },
    });
  };

  const ActionDataPending = [
    // ...(!( userDetails?.department?.name === "SCM")
    //          ? [
    //              {
    //               label: "Update",
    //      className: "btn btn-link",
    //      icon: <EditIcon />,
    //      title: "update",
    //      clickHandler: HandleUpdate,
    //              },
    //            ]
    //          : []),
    {
      label: "View",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleViewPending,
    },
  ];

  const GetSiteList = (companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      let API =
        userDetails?.type === 2
          ? apiUrl.get_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`
          : apiUrl.get_user_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`;

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData = response.data?.site?.map((item) => ({
              value: item?.site?.id || item.id,
              label: item?.site?.name || item.name,
            }));

            const isSitePresent = response.data?.site?.some((item) => {
              const id = item?.site?.id || item.id;
              return id == filterDetails?.siteId;
            });

            setPageStates((prev) => ({
              ...prev,
              ...(isSitePresent ? { isInitial: false } : { siteId: "" }),
              siteList: formattedData || [],
            }));

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  const GetOfficeList = (companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      let API =
        apiUrl.get_site +
        `?type=office&pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
        }`;

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            setPageStates((prev) => ({
              ...prev,
              officeList: response.data?.site || [],
            }));

            resolve(response.data?.site || []);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= filterDetails?.totalPages) {
      dispatch(
        updateFiltersStates({
          currentPage: PageNo,
        }),
      );
    }
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 500);
  };

  const handleChangePageSize = (value) => {
    dispatch(
      updateFiltersStates({
        currentPage: 1,
        pageSize: value,
      }),
    );
  };

  const sortHandler = (data, type) => {
    setPageStates((prevState) => ({
      ...prevState,
      ...(type == "site" && { siteId: data?.site || data?.office, officeName: data?.office || "" }),
      ...(type == "companyId" && { companyId: data?.companyId, siteId: "" }),
    }));
    dispatch(
      updateFiltersStates({
        ...(!type && { department: data?.department }),
        ...(!type && { designation: data?.designation }),
        ...(type == "site" && { siteId: data?.site || data?.office }),
        ...(type === "companyId" && { companyId: data?.companyId }),
      }),
    );

    if (ActiveTab === 2 && type == "companyId") {
      GetSiteList(data?.companyId);
    }

    if (ActiveTab === 1 && type == "companyId") {
      GetOfficeList(data?.companyId);
    }

    if (type === "department" && data?.department) {
      getDepartmentAndDesignation("designation", data?.department);
    }
  };

  const sortList = {
    department: pageStates?.departmentList,
    designation: pageStates?.designationList,
    ...(pageStates.siteList && { site: pageStates.siteList }),
    companyList: pageStates?.companyList,
    resetState: ActiveTab,
  };

  const sortListOffice = {
    department: pageStates?.departmentList,
    designation: pageStates?.designationList,
    ...(pageStates.officeList?.length > 0 && { office: pageStates.officeList }),
    companyList: pageStates?.companyList,
    resetState: ActiveTab,
  };

  const singleDateChangeHandler = (date) => {
    if (!date || !moment(date).isValid()) return;

    const selectedStartDate = moment(date)
      .startOf("month")
      .format("YYYY-MM-DD");
    const selectedEndDate = moment(date).endOf("month").format("YYYY-MM-DD");
    dispatch(updateDateFilter([selectedStartDate, selectedEndDate]));
  };

  const handleExport = () => {
    let data = {
      exportDataType: "attendanceSummary",
      userType:
        userDetails?.type === 2 ||
          (userDetails?.type == 1 && userDetails?.department?.name === "HRM") ||
          (userDetails?.type == 1 &&
            userDetails?.department?.name === "Management")
          ? ActiveTab == 2
            ? 0
            : 1
          : 0,
      startDate: dateFilter?.[0],
      endDate: dateFilter?.[1],
      siteId: filterDetails?.siteId,
      companyId: filterDetails?.companyId,
      department: filterDetails?.department,
      designation: filterDetails?.designation,
    };
    ExportDataHandler(data, "AttendanceSummary");
  };

  const handleLockAtt = () => {
    const postData = {
      siteId: filterDetails?.siteId,
      startDate: dateFilter[0],
      endDate: dateFilter[1],
      userType: ActiveTab === 1 ? "1" : "0",
    };
    setIsLoading(true);
    callApi(apiUrl.lock_attendance, {
      method: "POST",
      data: postData,
    }).then((response) => {
      setIsLoading(false);
      if (response?.status) {
        toggleModal();
        GetSummary();
        toast.success("Attendance Locked");
      } else {
        toast.error(response?.message);
      }
    });
  };

  const handleCreateSalary = () => {
    const postData = {
      siteId: filterDetails?.siteId,
      startDate: dateFilter[0],
      endDate: dateFilter[1],
      userType: ActiveTab === 1 ? "1" : "0",
    };
    setIsLoading(true);
    callApi(apiUrl.create_monthly_user_salary, {
      method: "POST",
      data: postData,
    }).then((response) => {
      setIsLoading(false);
      if (response?.status) {
        toggleModal();
        GetSummary();
        toast.success("Salary Created");
      } else {
        toggleModal();
        toast.error(response?.message);
      }
    });
  };

  const handlePreview_UpdateGeneratedSalary = () => {
    let siteName = "";
    if (ActiveTab === 1) {
      const office = pageStates.officeList?.find(
        (item) => item.id == filterDetails?.siteId || item.id == pageStates?.siteId
      );
      siteName = office?.name;
    } else {
      const site = pageStates.siteList?.find(
        (item) => item.value == filterDetails?.siteId || item.value == pageStates?.siteId
      );
      siteName = site?.label;
    }
    navigate(
      RoutesLink.view_create_salary_details +
      `/${moment(dateFilter[0]).format("MM-YYYY")}`,
      {
        state: {
          siteName: siteName || "",
          userType: ActiveTab === 1 ? 1 : 0,
        },
      },
    );
  };

  const handleGenerateSalaryPreview = () => {
    const postData = {
      siteId: filterDetails?.siteId,
      startDate: dateFilter[0],
      endDate: dateFilter[1],
      userType: ActiveTab === 1 ? "1" : "0",
    };
    setIsLoading(true);
    callApi(apiUrl.create_monthly_user_salary_view, {
      method: "POST",
      data: postData,
    }).then((response) => {
      setIsLoading(false);
      if (response?.status) {
        const site = pageStates.siteList.find(
          (item) => item.value == filterDetails?.siteId,
        );
        navigate(
          RoutesLink.view_create_salary_details +
          `/${moment(dateFilter[0]).format("MM-YYYY")}`,
          {
            state: {
              siteName: site?.label,
              userType: ActiveTab === 1 ? "1" : "0",
            },
          },
        );
      } else {
        toast.error(response?.message);
      }
    });
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      }),
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  return (
    <>
      <div className="content">
        <MainHeading
          title={"Attendance Summary"}
          showDefaultDate={true}
          singleDateChangeHandler={singleDateChangeHandler}
          pickerType="month"
        />
        {userDetails?.type === 2 ||
          (userDetails?.type == 1 && userDetails?.department?.name === "HRM") ||
          (userDetails?.type == 1 &&
            userDetails?.department?.name === "Management") ? (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <Nav tabs className="nav nav-tabs border-0 mb-4">
                <NavItem className="nav-item">
                  <NavLink
                    className={
                      ActiveTab === 1
                        ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-2 active"
                        : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-2"
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleTab(1)}
                  >
                    Office Staff Attendance
                  </NavLink>
                </NavItem>
                <NavItem className="nav-item ">
                  <NavLink
                    className={
                      ActiveTab === 2
                        ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0 active"
                        : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0"
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleTab(2)}
                  >
                    Site Staff Attendance
                  </NavLink>
                </NavItem>
              </Nav>
              {(pageStates?.siteId && pageStates?.attendanceList?.length > 0 && !pageStates?.tableLoader) && (
                <div className="d-flex gap-2">
                  {!pageStates?.isSalaryCreated && pageStates?.isPreviewGenerated && <button
                    title={"Re-Generate Salary Preview"}
                    className="btn btn-outline-primary"
                    disabled={isLoading || pageStates?.isSalaryCreated}
                    onClick={handleGenerateSalaryPreview}
                  >
                    {isLoading && <Spinner />}
                    <i className="bi bi-coin"></i>
                    Re-Generate Salary Preview
                  </button>}
                  <button
                    title={pageStates?.isPreviewGenerated ? "Preview/Update Generated Salary" : "Generate Salary Preview"}
                    className="btn btn-outline-primary"
                    disabled={isLoading || pageStates?.isSalaryCreated}
                    onClick={() => {
                      if (pageStates?.isPreviewGenerated)
                        handlePreview_UpdateGeneratedSalary();
                      else {
                        handleGenerateSalaryPreview();
                      }
                    }}
                  >
                    {isLoading && !pageStates?.isPreviewGenerated && <Spinner />}
                    <i className="bi bi-coin"></i>
                    {pageStates?.isSalaryCreated
                      ? "Salary Created"
                      : pageStates?.isPreviewGenerated ? "Preview/Update Generated Salary" : "Generate Salary Preview"}
                  </button>

                </div>
              )}
            </div>
            <TabContent activeTab={ActiveTab}>
              <TabPane tabId={1}>
                <Fade in={ActiveTab === 1} timeout={200}>
                  <div className="card mb-4">
                    <div className="card-body">
                      <FilterComponent
                        filterArray={sortListOffice}
                        sortHandler={sortHandler}
                        handleSearch={handleSearchChange}
                        searchPlaceHolder={"Search by Employee"}
                        handleData={sortHandler}
                        pageStates={pageStates}
                        orderByHandler={orderByHandler}
                        orderByList={orderByList}
                        getCompany={GetCompanyList}
                        getSite={GetOfficeList}
                      />
                      <CommonTable
                        TableHeading={TableHeadingOffice}
                        TableData={pageStates?.attendanceList}
                        currentPage={filterDetails?.currentPage}
                        ActionData={ActionDataPending}
                        PageChangeHandler={PageChangeHandler}
                        isLoading={pageStates?.tableLoader}
                        totalPages={filterDetails?.totalPages}
                        count={filterDetails?.count}
                        handleChangePageSize={handleChangePageSize}
                        pageSize={filterDetails.pageSize}
                      />
                    </div>
                  </div>
                </Fade>
              </TabPane>
              <TabPane tabId={2}>
                <Fade in={ActiveTab === 2} timeout={200}>
                  <div className="card mb-4">
                    <div className="card-body">
                      <FilterComponent
                        filterArray={sortList}
                        sortHandler={sortHandler}
                        handleSearch={handleSearchChange}
                        searchPlaceHolder={"Search by Employee"}
                        handleData={sortHandler}
                        pageStates={pageStates}
                        orderByHandler={orderByHandler}
                        orderByList={orderByList}
                        handleExport={
                          pageStates?.attendanceList?.length > 0
                            ? handleExport
                            : null
                        }
                        getCompany={GetCompanyList}
                        getSite={GetSiteList}
                      />
                      <CommonTable
                        TableHeading={TableHeadingSite}
                        TableData={pageStates?.attendanceList}
                        ActionData={ActionDataPending}
                        currentPage={filterDetails?.currentPage}
                        PageChangeHandler={PageChangeHandler}
                        isLoading={pageStates?.tableLoader}
                        totalPages={filterDetails?.totalPages}
                        count={filterDetails?.count}
                        handleChangePageSize={handleChangePageSize}
                        pageSize={filterDetails?.pageSize}
                      />
                    </div>
                  </div>
                </Fade>
              </TabPane>
            </TabContent>
          </>
        ) : (
          <div className="card mb-4">
            <div className="card-body">
              <FilterComponent
                filterArray={sortList}
                sortHandler={sortHandler}
                handleSearch={handleSearchChange}
                searchPlaceHolder={"Search by Employee"}
                handleData={sortHandler}
                pageStates={pageStates}
                handleExport={
                  pageStates?.attendanceList?.length > 0 ? handleExport : null
                }
              />
              <CommonTable
                TableHeading={TableHeadingSite}
                ActionData={ActionDataPending}
                TableData={pageStates?.attendanceList}
                currentPage={filterDetails?.currentPage}
                PageChangeHandler={PageChangeHandler}
                isLoading={pageStates?.tableLoader}
                totalPages={filterDetails?.totalPages}
                count={filterDetails?.count}
                handleChangePageSize={handleChangePageSize}
                pageSize={filterDetails.pageSize}
              />
            </div>
          </div>
        )}
      </div>
      <LockAttConfirmationModel
        modal={modal}
        toggle={() => toggleModal()}
        submitHandler={
          modalType === "createSalary" ? handleCreateSalary : handleLockAtt
        }
        isLoading={isLoading}
        type={modalType}
      />
    </>
  );
}
